export default __webpack_public_path__ + "static/media/no-permission.0719efa9.jpg";